export default class FormHandler {
    constructor() {
        this.personType = '1';
    }

    initializePersonTypeHandling() {
        jQuery('#billing-pf-fields').show();
        jQuery('#billing-pj-fields').hide();
        jQuery('#billing-pf-fields input').prop('required', true);
        jQuery('#billing-pj-fields input').prop('required', false);

        this.initializeCpfMask();

        jQuery('input[name="billing_persontype"]').on('change', (e) => {
            const isPF = e.target.value === '1';
            this.personType = e.target.value;

            jQuery('#billing-pf-fields').toggle(isPF);
            jQuery('#billing-pj-fields').toggle(!isPF);

            jQuery('#billing-pf-fields input').prop('required', isPF);
            jQuery('#billing-pj-fields input').prop('required', !isPF);

            if (isPF) {
                this.initializeCpfMask();
            } else {
                this.initializeCnpjMask();
            }
        });
    }

    initializeCpfMask() {
        const cpfInput = document.querySelector('input[name="billing_cpf"]');
        if (cpfInput && typeof IMask === 'function') {
            IMask(cpfInput, {
                mask: '000.000.000-00',
            });
        }
    }

    initializeCnpjMask() {
        const cnpjInput = document.querySelector('input[name="billing_cnpj"]');
        if (cnpjInput && typeof IMask === 'function') {
            IMask(cnpjInput, {
                mask: '00.000.000/0000-00',
            });
        }
    }

    validateAndGetBillingData() {
        const personType = jQuery('input[name="billing_persontype"]:checked').val() || '1';
        const isPF = personType === '1';

        const billingData = {
            persontype: personType,
        };
        let isValid = true;

        const visibleFieldsContainer = isPF ? '#billing-pf-fields' : '#billing-pj-fields';

        jQuery(`${visibleFieldsContainer} .missing-data input`).each(function () {
            const field = jQuery(this);
            const fieldName = field.attr('name').replace('billing_', '');
            const value = field.val().trim();

            if (!value) {
                field.addClass('error');
                isValid = false;
            } else {
                field.removeClass('error');
                billingData[fieldName] = value;
            }
        });

        jQuery(`${visibleFieldsContainer} .has-data .field-display`).each(function () {
            const field = jQuery(this);
            const label = field.find('strong').text();
            let value = field.text();

            Object.keys(vindiOneClick.required_fields).forEach(key => {
                const fieldLabel = vindiOneClick.required_fields[key] + ':';
                value = value.replace(fieldLabel, '').trim();
            });

            const fieldName = Object.keys(vindiOneClick.required_fields)
                .find(key => vindiOneClick.required_fields[key] === label.replace(':', ''));

            if (fieldName) {
                billingData[fieldName] = value;
            }
        });
        return {
            isValid: isValid,
            data: billingData,
            message: isValid ? '' : 'Por favor, preencha todos os campos obrigatórios.'
        };
    }
}